import { useMemo, useState } from 'react';
import { ContentWrapper } from '@/components/ContentWrapper';
import { ViewSwitch } from '@/components/shared/ViewSwitch';
import {
    Heading,
    TEXT_SIZE,
    FONT_WEIGHT,
    LINE_HEIGHT,
    PageSubHeading
} from '@/typography/Typography';
import { CompanyBalance } from '@/pages/history/CompanyBalance';
import { TransactionListType, TransactionsList } from './TransactionsList';
import { Box, Typography } from '@mui/material';
import { useGetPendingTransactions } from '@/services/paymentsQuery';
import { TransactionStatus } from '@/models/transaction';
import { useUser } from '@/contexts/user/UserContext';

export const PaymentsPage = () => {
    const { data: pendingTransactionResponse } = useGetPendingTransactions();
    const { user } = useUser();

    const viewSwitchItems = useMemo(() => {
        console.log(pendingTransactionResponse?.data?.transactions);
        let list = [
            {
                primaryText: 'Awaiting Manager',
                badgeText:
                    pendingTransactionResponse?.data?.transactions
                        ?.filter(
                            (transaction) =>
                                transaction.status ==
                                TransactionStatus.PendingApproval
                        )
                        .length?.toString() ?? '',
                route: 'awaiting-manager',
                routeComponent: (
                    <TransactionsList
                        key={TransactionListType.AwaitingManager}
                        type={TransactionListType.AwaitingManager}
                    />
                )
            }
        ];

        if (user?.role === 'SuperAdmin') {
            list.push({
                primaryText: 'Awaiting Bank',
                badgeText:
                    pendingTransactionResponse?.data?.transactions
                        ?.filter(
                            (transaction) =>
                                transaction.status ==
                                TransactionStatus.AwaitingBank
                        )
                        .length?.toString() ?? '',
                route: 'awaiting-bank',
                routeComponent: (
                    <TransactionsList
                        key={TransactionListType.AwaitingBank}
                        type={TransactionListType.AwaitingBank}
                    />
                )
            });
        }

        return list;
    }, [pendingTransactionResponse?.data?.transactions, user?.role]);

    const [tabIndex, setTabIndex] = useState<number | null>(null);

    return (
        <ContentWrapper>
            <>
                <Box display={'flex'} justifyContent={'space-between'}>
                    <Typography variant="h4" marginBottom="5px">
                        <Heading
                            fontSize={TEXT_SIZE.MEDIUM_LARGE}
                            fontWeight={FONT_WEIGHT.MEDIUM}
                            lineHeight={LINE_HEIGHT.XLARGE}
                        >
                            Pending transactions
                        </Heading>
                        <PageSubHeading>
                            Your employees have requested the following
                            withdrawals
                        </PageSubHeading>
                    </Typography>
                    <CompanyBalance />
                </Box>
                <ViewSwitch
                    itemList={viewSwitchItems}
                    setSelectedIndex={setTabIndex}
                    selectedIndex={tabIndex}
                />
            </>
        </ContentWrapper>
    );
};
